import React from "react";
import { Button } from "@blueprintjs/core";
import { SUBMENU } from "../utils/constants";
import { withRouterParams } from "../utils/withRouterParams";
import "../css/SubmenuPills.scss";

class Submenu extends React.Component {
    /* ─────────────────────────  Click handler  ───────────────────────── */
    handleClick = (slug) => {
        const { role, location, navigate } = this.props;

        /* copiem toţi parametrii existenţi  */
        const params = new URLSearchParams(location.search);

        /* tab nou ales */
        params.set("tab", slug);

        /* 🔑 REMOVE view-specific params  */
        params.delete("view");
        params.delete("team_id");
        params.delete("training_id");
        
                  // dacă ai şi id în query
        // mai adaugă aici alte chei de detaliu dacă e cazul (ex: params.delete("trainingId"))

        /* ADMIN, SUPERADMIN, ECHIPA → query-string */
        if (["admin", "superadmin", "echipa"].includes(role)) {
            const dest = role === "admin"
                ? `/admin`
                : role === "superadmin"
                    ? `/superadmin`
                    : `/echipa`;
            navigate(`${dest}?${params.toString()}`);
        }
        /* SEGMENT-PATH roles (viewer etc.) */
        else {
            const base = location.pathname.split("/").slice(0, -1).join("/");
            navigate(`${base}/${slug}`);
        }
    };


    /* ─────────────────────────  Render  ───────────────────────── */
    render() {
        const { role, location } = this.props;
        const params = new URLSearchParams(location.search);

        /* 1️⃣  Slug activ */
        let activeSlug;

        if (["admin", "superadmin", "echipa"].includes(role)) {
            activeSlug = params.get("tab");
        } else {
            activeSlug = location.pathname.split("/").pop();
        }

        /* 2️⃣  Items din SUBMENU */
        const items = SUBMENU[role] || [];

        return (
            <div className="submenu-pills">
                {items.map((item) => (
                    <Button
                        key={item.slug}
                        text={item.label}
                        minimal
                        className={`pill-btn ${activeSlug === item.slug ? "active-pill" : ""
                            }`}
                        onClick={() => this.handleClick(item.slug)}
                    />
                ))}
            </div>
        );
    }
}

export default withRouterParams(Submenu);
